export const constants = {
    minutesInHour: 60,
    hoursInDay: 24,
    lengthFor0_00Format: 4,
    lengthFor00_00Format: 5,
};
